var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"om-base",class:[
    {'om-rounded': _vm.rounded }
]},[_c('canvas',{staticClass:"myCanvas2",attrs:{"id":'canvasx'}})])}
var staticRenderFns = []

export { render, staticRenderFns }